import dayjs from "dayjs";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

import "dayjs/locale/en-ca";
import { Models } from "../api/types";

export const initializeDayjsPlugins = () => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(relativeTime);
  dayjs.extend(localizedFormat);
  dayjs.extend(localeData);
};
export const changeDayjsLocale = (
  stripeRegion: Models<"StripeRegion"> | undefined
): void => {
  dayjs.locale(
    {
      US: "en",
      CA: "en-ca",
    }[stripeRegion ?? "US"]
  );
};

export const formatToLongDate = (date: string): string => {
  let formatted = "";

  if (dayjs.locale() === "en-ca") {
    formatted = date
      .replace(/[a-z]/gi, "")
      .replace(/^(\d\d\d\d)(\d)$/g, "$1-$2")
      .replace(/^(\d\d\d\d-\d\d)(\d+)$/g, "$1-$2");
  } else {
    formatted = date
      .replace(/[a-z]/gi, "")
      .replace(/^(\d\d)(\d)$/g, "$1/$2")
      .replace(/^(\d\d\/\d\d)(\d+)$/g, "$1/$2");
  }
  return formatted;
};

export const formatToSimpleDate = (date: string): string => {
  if (!date || !dayjs(date).isValid()) return "";
  return dayjs(date).format("MMMM D, YYYY");
};

export const getUserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    // Fallback to UTC offset
    const offset = new Date().getTimezoneOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset <= 0 ? "+" : "-";
    return `UTC${sign}${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  }
};

export const convertLocalTimeToUTC = (date: Date, time: string): string => {
  const [hours, minutes] = time.split(":").map(Number);
  const localDateTime = new Date(date);
  localDateTime.setHours(hours, minutes, 0, 0);

  const timezone = getUserTimezone();

  // Convert from user's timezone to UTC
  return dayjs.tz(localDateTime, timezone).utc().toISOString();
};

export const convertUTCToLocalTime = (utcDateTime: string): string => {
  const timezone = getUserTimezone();

  // Convert from UTC to user's timezone
  return dayjs.utc(utcDateTime).tz(timezone).format("YYYY-MM-DDTHH:mm:ss");
};
